import { IntelligenceEventType, PortSuggestionStreamEvent } from '../../../common/api/clients/intelligence.api';
import { translate } from '../../../common/helpers/translate.helper';
import { IntelligenceProgressIndicator } from '../../create-enquiry/components/intelligence/IntelligenceProgressIndicator';

interface SuggestionProgressIndicatorProps {
    events: PortSuggestionStreamEvent[];
}

export const SuggestionProgressIndicator = ({ events }: SuggestionProgressIndicatorProps) => {
    const eventData = events.map((event) => event.data);
    const eventTypes = events.map((event) => event.event);

    const gatheringFinished = eventData.includes('FETCHING_DATA_FINISHED');
    const reviewingStarted = eventData.includes('CALLING_LLM_STARTED');
    const reviewingFinished = eventData.includes('CALLING_LLM_FINISHED');

    const hasLLMUpdates = eventTypes.includes(IntelligenceEventType.LLM_UPDATE);

    const gatheringActive = !gatheringFinished && !hasLLMUpdates;
    const reviewingActive = reviewingStarted && !reviewingFinished && !hasLLMUpdates;
    const formulatingActive = hasLLMUpdates && !reviewingFinished;

    const steps = [
        {
            text: translate('closelinkInsights.gatheringInformation'),
            description: translate('closelinkInsights.gatheringInformation.description'),
            isActive: gatheringActive,
            isVisible: true,
        },
        {
            text: translate('closelinkInsights.reviewingOptions'),
            description: translate('closelinkInsights.reviewingOptions.description'),
            isActive: reviewingActive,
            isVisible: reviewingStarted,
        },
        {
            text: translate('closelinkInsights.generatingRecommendation'),
            isActive: formulatingActive,
            isVisible: hasLLMUpdates,
        },
    ];

    return <IntelligenceProgressIndicator steps={steps} />;
};
